/* eslint-disable jsx-a11y/alt-text */
import { CheckCircleFilled, CheckCircleOutlined } from "@ant-design/icons";
import { isMobile } from "react-device-detect";

import "./home.css";
import moment from "moment";

export function Checker() {
  const searchParams = new URLSearchParams(window.location.search);
  const submissionId =
    searchParams.get("submission_id") || "101072256478904948";

  return isMobile ? (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        background: "#f0f2f5",
        display: "flex"
      }}
    >
      <div
        style={{
          padding: "20px 0",
          position: "relative",
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center"
        }}
      >
        <div
          style={{
            justifyContent: "center",
            width: "100%",
            alignItems: "self-start",
            margin: "0 10px",
            marginTop: "60px",
            display: "flex",
            justifyItems: "center"
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column"
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#fff",
                border: "none",
                borderRadius: "8px",
                boxShadow:
                  "0 2px 4px rgba(0, 0, 0, .1), 0 8px 16px rgba(0, 0, 0, .1)",
                boxSizing: "border-box",
                padding: "20px 15px 28px",
                width: "100%",
                height: "100%"
              }}
            >
              <p
                style={{
                  color: "#65676B",
                  fontWeight: "600",
                  fontSize: ".8125rem",
                  marginBottom: "4px"
                }}
              >
                Submission ID: {submissionId}
              </p>
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  marginBottom: "20px"
                }}
              >
                In review
              </div>
              <div style={{ display: "flex", marginBottom: "12px" }}>
                <div style={{ margin: "0 10px" }}>
                  <CheckCircleFilled
                    rev={undefined}
                    style={{ fontSize: "20px", color: "#c0c5cb" }}
                  />
                </div>
                <div>
                  <div className="checker_title">Submission received</div>
                  <div className="subTitle">
                    Your submission was received on {moment().format("ll")}
                  </div>
                </div>
              </div>
              <div style={{ marginBottom: "12px", display: "flex" }}>
                <div style={{ margin: "0 10px" }}>
                  <CheckCircleFilled
                    rev={undefined}
                    style={{ fontSize: "20px", color: "#036cd1" }}
                  />
                </div>
                <div>
                  <div className="checker_title" style={{ color: "#000000" }}>
                    In review
                  </div>
                  <div className="subTitle" style={{ color: "#000000" }}>
                    We're reviewing your submission. Review usually takes 48
                    hours.
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", marginBottom: "12px" }}>
                <div style={{ margin: "0 10px" }}>
                  <CheckCircleOutlined
                    rev={undefined}
                    style={{ fontSize: "20px", color: "#c0c5cb" }}
                  />
                </div>
                <div>
                  <div className="checker_title">Decision made</div>
                  <div className="subTitle">
                    You'll receive an email once we've made a decision.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        background: "#f0f2f5",
        display: "flex"
      }}
    >
      <div
        style={{
          padding: "20px 0",
          position: "relative",
          width: "980px",
          height: "100vh",
          display: "flex",
          justifyContent: "center"
        }}
      >
        <div
          style={{
            justifyContent: "center",
            width: "505px",
            alignItems: "self-start",
            marginTop: "60px",
            display: "flex",
            justifyItems: "center"
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column"
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#fff",
                border: "none",
                borderRadius: "8px",
                boxShadow:
                  "0 2px 4px rgba(0, 0, 0, .1), 0 8px 16px rgba(0, 0, 0, .1)",
                boxSizing: "border-box",
                padding: "20px 15px 28px",
                width: "560px",
                height: "307px"
              }}
            >
              <p
                style={{
                  color: "#65676B",
                  fontWeight: "600",
                  fontSize: ".8125rem",
                  marginBottom: "4px"
                }}
              >
                Submission ID: {submissionId}
              </p>
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  marginBottom: "20px"
                }}
              >
                In review
              </div>
              <div style={{ display: "flex", marginBottom: "12px" }}>
                <div style={{ margin: "0 10px" }}>
                  <CheckCircleFilled
                    rev={undefined}
                    style={{ fontSize: "20px", color: "#c0c5cb" }}
                  />
                </div>
                <div>
                  <div className="checker_title">Submission received</div>
                  <div className="subTitle">
                    Your submission was received on {moment().format("ll")}
                  </div>
                </div>
              </div>
              <div style={{ marginBottom: "12px", display: "flex" }}>
                <div style={{ margin: "0 10px" }}>
                  <CheckCircleFilled
                    rev={undefined}
                    style={{ fontSize: "20px", color: "#036cd1" }}
                  />
                </div>
                <div>
                  <div className="checker_title" style={{ color: "#000000" }}>
                    In review
                  </div>
                  <div className="subTitle" style={{ color: "#000000" }}>
                    We're reviewing your submission. Review usually takes 48
                    hours.
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", marginBottom: "12px" }}>
                <div style={{ margin: "0 10px" }}>
                  <CheckCircleOutlined
                    rev={undefined}
                    style={{ fontSize: "20px", color: "#c0c5cb" }}
                  />
                </div>
                <div>
                  <div className="checker_title">Decision made</div>
                  <div className="subTitle">
                    You'll receive an email once we've made a decision.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
